import React from 'react';
import PropTypes from 'prop-types';
import {
    Container,
    CardContainer,
    ImageContainer,
    Image,
    Content,
    Title,
    Description,
} from '../styled';

const WhyRent = ({ content }) => {
    if (Array.isArray(content?.cards)) {
        return (
            <Container>
                {content.cards.map((card) => (
                    <CardContainer>
                        <ImageContainer imgSize={180}>
                            <Image
                                src={card.icon.url}
                                imgUrls={card.icon.url}
                                alt={card.icon.title}
                                imgSize={180}
                            />
                        </ImageContainer>
                        <Content>
                            <Title>{card.title}</Title>
                            <Description html={card.description} />
                        </Content>
                    </CardContainer>
                ))}
            </Container>
        );
    }
    return null;
};

WhyRent.propTypes = {
    content: PropTypes.shape({
        cards: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string,
                title: PropTypes.string,
                description: PropTypes.string,
                icon: PropTypes.shape({
                    image: PropTypes.shape({
                        width: PropTypes.number,
                        height: PropTypes.number,
                    }),
                    url: PropTypes.string,
                    title: PropTypes.string,
                }),
            }),
        ),
    }).isRequired,
};

export default WhyRent;
